import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import moment from "moment";
import styles from "./CollaboratorClientsFolders.local.scss";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import classnames from "classnames";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { fetchCapacityPlaningCollaboratorClient } from "Thunks";
import {
  setCapacityPlaningCollaborator,
  setCapacityPlaningCollaboratorFilterName,
  setCapacityPlaningCollaboratorState,
  setCapacityPlaningCollaboratorAnnual,
  setCapacityPlaningCollaboratorDate,
  setCapacityPlaningCollaboratorRole
} from "Actions";
import { StackedBarChart } from "../Common/Charts/StackedBarChart";
import CapacityPlaningTable from "../CapacityPlanning/CapacityPlaningTable";
import CollaboratorClientsFoldersFilter from "./CollaboratorClientsFoldersFilter";
import { NEW_COLLABORATOR_ROLE_FILTER } from "Config";
import FolderStateFilter from "../CapacityPlanning/FolderStateFilter";

class CollaboratorClientsFolders extends PureComponent {
  //******************   Content Functions  **************//
  intervalID;
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      roleDivIsVisible: false,
      tableIsVisible: true,
      graphIsVisible: false,
      qpFilter: 40,
      period: "ANNUAL",
      date: moment(),
      year: moment().year()
    };
  }

  componentDidMount() {
    const { date } = this.state;
    const { dispatch, user } = this.props;
    this.setState({ loading: true });
    dispatch(
      setCapacityPlaningCollaborator({
        erpId: user.adminisId,
        name: user.firstName
      })
    );
    dispatch(setCapacityPlaningCollaboratorAnnual(true));
    this.handleFetchCapacityPlaningCollaboratorClient(date);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleFetchCapacityPlaningCollaboratorClient = date => {
    const { dispatch } = this.props;
    dispatch(fetchCapacityPlaningCollaboratorClient(date));
  };

  renderCapacityPlanningClients = () => {
    const {
      fetching,
      fetched,
      capacityPlaningData,
      error,
      clientName
    } = this.props;
    let data = capacityPlaningData.dynamic;
    return (
      <div className={styles.data_block}>
        <div className={classnames(styles.header, "medium-12")}>
          <div className={"row"}>
            <FolderStateFilter
              value={this.state.qpFilter}
              handleDisplayChangeStatusFolders={
                this.handleDisplayChangeStatusFolders
              }
            />
          </div>
        </div>
        <div className={classnames(styles.filters, "row medium-12")}>
          <div className={classnames(styles.role, "medium-4")}>
            <div className="filter-wrapper">
              <div className="filter-wrapper">
                {this.renderCollaboratorRoleSelect()}
              </div>
            </div>
          </div>
          <div className={classnames(styles.search, "medium-6")}>
            <TTPFilterHorizontalBar
              filters={[]}
              searchPlaceholder="Search by client name"
              searchInputValue={clientName}
              handleSearchInputChange={this.handleSearchInputChange.bind(this)}
              cssClass={classnames(styles.forceHideBorderSearch, "medium-12")}
              fetching={fetching}
            />
          </div>
        </div>
        <div className={styles.data}>
          {fetching ? (
            <div className={styles.ripple_loading}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          ) : fetched && data && data.data ? (
            this.state.tableIsVisible ? (
              data.data.dataTable.data.length > 0 ? (
                this.renderCollaboratorClientsFoldersTable(data)
              ) : (
                <NotFoundV2 />
              )
            ) : data.data.dataChart.length > 0 ? (
              this.renderCollaboratorClientsFoldersChart(data)
            ) : (
              <NotFoundV2 />
            )
          ) : (
            error && this.renderCollaboratorClientsFoldersCallout(error)
          )}
        </div>
      </div>
    );
  };

  renderCollaboratorClientsFoldersCallout = error => {
    switch (error.code) {
      case 170010:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noOrganization")}
            buttonIgnored={true}
          />
        );
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("error1")}
            buttonIgnored={true}
          />
        );
      case 170042:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noTimeSheetMatches")}
            buttonIgnored={true}
          />
        );
      case 170045:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("collaboratorNotArrivedYet")}
            buttonIgnored={true}
          />
        );
      case 170046:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("collaboratorHasLeft")}
            buttonIgnored={true}
          />
        );
      case 170047:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("collaboratorNeedConfiguration")}
            buttonIgnored={true}
          />
        );
      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={true}
          />
        );
    }
  };

  renderCollaboratorRoleSelect = () => {
    const { role } = this.props;
    const { roleDivIsVisible } = this.state;
    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select_role +
          " " +
          (roleDivIsVisible ? styles.customed_select_role_opened : "")
        }
      >
        <div className={styles.customed_select_role_header}>
          <span>{role ? role : "Tous"}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayCollaboratorRoleSelect}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {roleDivIsVisible && (
          <div className={styles.customed_select_role_body}>
            <div className={styles.customed_select__role_body_options}>
              {NEW_COLLABORATOR_ROLE_FILTER.map(item => (
                <div
                  className={styles.customed_select_role_body_option}
                  onClick={() => this.handleSelectCollaboratorRole(item.value)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  handleDisplayCollaboratorRoleSelect = () => {
    this.setState(state => {
      return {
        roleDivIsVisible: !state.roleDivIsVisible
      };
    });
  };

  handleSelectCollaboratorRole = item => {
    const { analyseDate, dispatch } = this.props;
    dispatch(setCapacityPlaningCollaboratorRole(item));
    dispatch(fetchCapacityPlaningCollaboratorClient(analyseDate));
    this.setState({ roleDivIsVisible: false });
    this.handleActivateTable();
  };

  handleDisplayChangeStatusFolders = (value, type) => {
    const { analyseDate, dispatch } = this.props;
    dispatch(setCapacityPlaningCollaboratorState(type));
    this.setState({
      qpFilter: value
    });
    dispatch(fetchCapacityPlaningCollaboratorClient(analyseDate));
  };

  renderCollaboratorClientsFoldersChart = data => {
    let dataModel = data.data.dataChart;
    let columns = data.columns;

    const capacityPlaningData = dataModel ? dataModel : [];

    let dataChart = [];
    let legendLabels = [];
    let dataKeysY = [];

    capacityPlaningData.forEach(item => {
      dataChart.push(item);
    });
    columns.forEach(item => {
      if (item.label !== "sum") {
        legendLabels.push(item.label + " Budget");
        legendLabels.push(item.label + " Réalisé");
        dataKeysY.push(item.label);
        dataKeysY.push(item.label + "real");
      }
    });
    return (
      <div className={styles.chart_content}>
        <StackedBarChart
          chartData={dataChart}
          dataKeys={["label"]}
          legendLabels={legendLabels}
          dataKeysY={dataKeysY}
          currency={true}
          stackId={true}
          tooltipValueFormat={"H"}
        />
      </div>
    );
  };

  renderCollaboratorClientsFoldersTable = data => {
    const { loggedAs, spaceAs } = this.props;
    let dataModel, columns, totalModel, collaborator;

    dataModel = data.data.dataTable.data;
    totalModel = data.data.dataTable.total;
    collaborator = data.collaborator;
    columns = data.columns;
    return (
      <div>
        <div className={styles.divBackground}>
          <div className={styles.theadBackground} />
          <div className={styles.firstColumnBackground} />
        </div>
        <div>
          <CapacityPlaningTable
            collaborator={collaborator}
            dataModel={dataModel}
            totalModel={totalModel}
            columns={columns}
            handleRedirectToTimeSheet={this.handleRedirectToTimeSheet}
            handleRedirectToBudgetSetting={this.handleRedirectToBudgetSetting}
            loggedAs={loggedAs}
            spaceAs={spaceAs}
          />
        </div>
      </div>
    );
  };

  handleActivateChart = () => {
    this.setState({
      tableIsVisible: false,
      graphIsVisible: true
    });
  };

  handleActivateTable = () => {
    this.setState({
      graphIsVisible: false,
      tableIsVisible: true
    });
  };

  handlePeriodFilterChange = (period, date, year) => {
    const { dispatch, lastDate } = this.props;
    period && this.setState({ period });
    date && this.setState({ date });
    year && this.setState({ year });
    period &&
      (period === "ANNUAL"
        ? dispatch(setCapacityPlaningCollaboratorAnnual(true))
        : dispatch(setCapacityPlaningCollaboratorAnnual(false)));
    period &&
      this.handleFetchCapacityPlaningCollaboratorClient(this.state.date);
    date && this.handleFetchCapacityPlaningCollaboratorClient(date);
    year && this.setState({ year: year });
    let newDate =
      moment().year() === moment(year).year()
        ? lastDate
          ? lastDate
          : this.state.date
        : new moment(year + "-12-31");
    year && dispatch(setCapacityPlaningCollaboratorDate(newDate));
    year &&
      this.setState({
        date: newDate
      });
    year && this.handleFetchCapacityPlaningCollaboratorClient(newDate);
  };

  handleSearchInputChange = word => {
    this.props.dispatch(setCapacityPlaningCollaboratorFilterName(word));
    this.handleFetchCapacityPlaningCollaboratorClient();
  };

  render() {
    let { period, date, year, tableIsVisible, graphIsVisible } = this.state;
    const { arrivalDate, lastDate } = this.props;
    return (
      <div className={styles.page_content}>
        <div className={styles.filter_content}>
          <CollaboratorClientsFoldersFilter
            onChangeFilter={this.handlePeriodFilterChange}
            handleActivateTable={this.handleActivateTable}
            handleActivateChart={this.handleActivateChart}
            tableIsVisible={tableIsVisible}
            graphIsVisible={graphIsVisible}
            lastDate={lastDate}
            arrivalDate={arrivalDate}
            period={period}
            date={date}
            year={year}
          />
        </div>
        <div className={styles.data_content}>
          {this.renderCapacityPlanningClients()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  // loggedAs: state.auth.loggedAs,
  spaceAs: state.auth.spaceAs,
  lng: state.params.lng,
  fetching: state.capacityPlaning.collaborator.fetching,
  fetched: state.capacityPlaning.collaborator.fetched,
  error: state.capacityPlaning.collaborator.error,
  currentOrganization: state.auth.currentOrganization,
  role: state.capacityPlaning.collaborator.filter.role,
  lastDate: state.capacityPlaning.collaborator.filter.lastDate,
  arrivalDate: state.capacityPlaning.collaborator.filter.arrivalDate,
  capacityPlaningData: state.capacityPlaning.collaborator.data
});

export default connect(mapStateToProps)(CollaboratorClientsFolders);



// WEBPACK FOOTER //
// ./src/components/CollaboratorClientsFolders/CollaboratorClientsFolders.js